export const INVITATION_STATUSES = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
} as const;

export const SCREEN_TYPES = {
  LIST: "list",
  FORM: "form",
  CHAT: "chat",
  BOARD: "board",
  REPORTS: "reports",
  DRIVE: "drive",
  DELIVERY_PARSER: "deliveryParser",
};

export const USER_ROLES = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
  OPERATOR: "operator",
  CUSTOMER: "customer",
  COURIER: "courier",
};

export const DEFAULT_ROLE = "defaultRole";

export const SMALL_SCREEN_WIDTH = 640; // Маленькие экраны (например, телефоны)
export const MEDIUM_SCREEN_WIDTH = 768; // Средние экраны (например, планшеты)
export const LARGE_SCREEN_WIDTH = 1024; // Большие экраны (например, ноутбуки и десктопы)
